import { useCallback, useRef, useState } from 'react';
import type { BackgroundVideoRef } from '../components/background-video/background-video';

type UseVideoControls = {
  videoRef: React.RefObject<BackgroundVideoRef | null>;
  isPlaying: boolean;
  play: () => void;
  pause: () => void;
  onPause: () => void;
  onTimeUpdate: () => void;
};

export function useVideoControls(initialPlaying = false): UseVideoControls {
  const videoRef = useRef<BackgroundVideoRef>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(initialPlaying);

  const pause = useCallback(() => {
    videoRef.current?.pause();
  }, []);

  const play = useCallback(() => {
    try {
      videoRef.current?.play();
    } catch {
      // Noop
    }
  }, []);

  const onPause = useCallback(() => setIsPlaying(false), []);
  const onTimeUpdate = useCallback(() => setIsPlaying(true), []);

  return { videoRef, isPlaying, play, pause, onPause, onTimeUpdate };
}
